import { BaseReducer } from '@hobs/utils/baseReducer';
import { EXPORT } from '@hobs/constants/reports';

class Reports extends BaseReducer {
  static defaultState = {
    export: {}
  };

  constructor() {
    super(Reports.defaultState);

    this.actionMap = {
      [EXPORT.ERROR]: this.exportReportError
    };
  }

  exportReportError = (state, action) => {
    return Object.assign({}, state, { export: action.error });
  };
}

export default new Reports().reducer;
